function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JerseyFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      stroke: "#E31D1C",
      strokeWidth: "1.35",
      d: "m-2.2 4.222-1.025-.619v17.394l1.024-.62 12.404-7.5.955-.577-.955-.578-12.404-7.5ZM26.36 4.216l1.014-.589V20.973l-1.014-.59-12.914-7.5-1.005-.583 1.005-.584 12.914-7.5Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E31D1C",
      fillRule: "evenodd",
      d: "M10.256 6.527s-.644 2.849 1.58 3.943c0 0 2.134-1.163 1.655-3.943 0 0-.917-.306-1.646-.306-.729 0-1.589.306-1.589.306Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      d: "m10.066 6.821-.487-1.418c.908-.312 1.692-.471 2.362-.471.686 0 1.402.167 2.145.493L13.483 6.8c-.562-.247-1.076-.367-1.542-.367-.484 0-1.112.127-1.875.39ZM11.887 8.925a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z"
    })]
  })]
}));
//# sourceMappingURL=Jersey.js.map